module.exports = __webpack_public_path__ + "static/media/SignUpImg.7b172fe7.svg";